module.exports = __webpack_public_path__ + "img/13_6.8992a483.png";